import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    //state存放状态,
    state: {
        bgc: window.localStorage.getItem("V2-bg") || "", //需要共用的数据

    },
    //getter为state的计算属性
    getters: {
        getName: (state) => state.name, //获取name
        getAge: (state) => state.age,
    },
    //mutations可更改状态的逻辑，同步操作
    mutations: {
        setBgc: (state, data) => state.bgc = data,

    },

    // 将store模块化
    modules: {}
})


// WEBPACK FOOTER //
// ./src/store/index.js